import { useState } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';
import { Form } from 'common/components';

import ModalCopyQasRequireFields from './ModalCopyQasRequireFields';
// redux
import { useSelector } from 'react-redux';
import gridSelector from 'common/components/grid-view/controllers/selectors';

const CopyQasRequireFields = () => {
  const [formInstance] = Form.useForm();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectedDetail = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const id = selectedDetail?.length === 1 ? selectedDetail[0].id : undefined;

  const handleClick = () => {
    setIsModalOpen((prev) => !prev);

    const productType = selectedDetail?.[0]?.productType;

    formInstance.setFieldsValue({
      ...formInstance.getFieldsValue(),
      productType,
    });
  };

  return (
    <>
      <RibbonButton
        icon={<CopyOutlined />}
        label={'Copy'}
        disabled={id === undefined || selectedDetail.length !== 1}
        onClick={handleClick}
      />
      {isModalOpen && (
        <ModalCopyQasRequireFields
          id={id}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          formInstance={formInstance}
        />
      )}
    </>
  );
};

export default CopyQasRequireFields;
